import React, { memo, FC } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  AspectRatio,
  Image,
  Center,
} from "@chakra-ui/react";
import { Else, If, Then } from "react-if";

interface IProps {
  url: string | null;
  isOpen: boolean;
  handleCloseModal: () => void;
  type: "video" | "image" | null;
}
const MediaModal: FC<IProps> = ({ url, isOpen, handleCloseModal, type }) => {
  if (!url || !type) {
    return null;
  }

  return (
    <Modal isCentered isOpen={isOpen} onClose={handleCloseModal} size={"auto"}>
      <ModalOverlay />
      <ModalContent width={{ base: "100%", lg: "80vw" }} bg="transparent">
        <ModalHeader />
        <ModalCloseButton color={"white"} />
        <ModalBody>
          <If condition={type === "image"}>
            <Then>
              <Center>
                <Image
                  src={url}
                  alt="commdevice product"
                  objectFit="cover"
                  loading="lazy"
                  width={"full"}
                />
              </Center>
            </Then>
            <Else>
              <AspectRatio maxW="100%" ratio={4 / 2} borderRadius={4}>
                {/* <iframe title="cdi" src={url} allowFullScreen /> */}
                <iframe
                  id="ytplayer"
                  width="640"
                  height="360"
                  src={url}
                  allowFullScreen
                ></iframe>
              </AspectRatio>
            </Else>
          </If>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default memo(MediaModal);
